import React, { FC, useContext } from 'react';

import ZoomInIcon from '@material-ui/icons/ZoomIn';

import { Button, styled } from '@grupoboticario/flora-react';

import content from 'src/common/content';

import ButtonWithIcon from 'src/components/atoms/ButtonWithIcon';

import { actions, CatalogContext } from 'src/contexts/Catalog';

import PageSelector from '../../../../organisms/PageSelector';
import { ChevronRight } from '@material-ui/icons';
import { sendCatalogEvent } from 'src/services/googleAnalytics/helpers/catalog';

const Styled = {
  Options: styled('div', {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '$4',
    width: '100%',

    position: 'absolute',
    bottom: '0',

    '@tablet': {
      padding: '$4 $0 $4',
      justifyContent: 'flex-start',
      position: 'relative',
    },

    variants: {
      fullScreen: {
        true: {
          left: '0',
          position: 'fixed',
          bottom: '0',
          width: '100%',
          zIndex: 10,
        },
      },
    },
  }),

  OptionsNavigation: styled('nav', {
    alignItems: 'center',
    display: 'flex',
    height: '32px',

    a: {
      marginLeft: '$8',
    },

    '@tablet': {
      marginRight: '$5',
    },
  }),

  ProductDetailButton: styled(Button, {
    marginLeft: 'auto',
  }),
};

export interface IDesktopOptionsBar {
  handleProductDetailClick: () => void;
  showProductDetailButton: boolean;
}

export const DesktopOptionsBar: FC<IDesktopOptionsBar> = ({
  handleProductDetailClick,
  showProductDetailButton,
}) => {
  const [, dispatch] = useContext(CatalogContext);

  const handleZoomInClick = () => {
    dispatch(actions.zoomIn());
    sendCatalogEvent.buttonClickZoomIn();
  };

  return (
    <Styled.Options>
      <Styled.OptionsNavigation>
        <ButtonWithIcon
          icon={<ZoomInIcon />}
          data-testid="zoomIn-button"
          aria-label={`Aumentar zoom do ${content.platform}`}
          onClick={handleZoomInClick}
        >
          Aumentar zoom
        </ButtonWithIcon>
      </Styled.OptionsNavigation>

      <PageSelector />

      {showProductDetailButton && (
        <Styled.ProductDetailButton
          rightIcon={<ChevronRight />}
          size="small"
          variant="conversion"
          onClick={handleProductDetailClick}
          data-testid="showProductDetail-button"
        >
          Veja detalhes dos produtos dessas páginas
        </Styled.ProductDetailButton>
      )}
    </Styled.Options>
  );
};
